import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ReportCreateSourceRoutes from "./Source/ReportCreateSourceRoutes";
import { getReportCreatePath, getReportCreateSourcePath, } from "../ReportRoutes";
import { getPreBaseRoute } from "../../../../../components";
const ReportCreateRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { path: getPreBaseRoute() + getReportCreateSourcePath(), component: ReportCreateSourceRoutes }), _jsx(Route, { path: getPreBaseRoute() + getReportCreatePath(), render: () => (_jsx(Redirect, { to: getPreBaseRoute() + getReportCreateSourcePath() })) })] }));
};
export default ReportCreateRoutes;
